<form [formGroup]="searchUserForm">
  <!-- MODO FLOATING -->
  <div
    *ngIf="useFloating"
    class="form-floating"
    ngbTooltip="Comienza a escribir para buscar un usuario por nombre">
    <input
      formControlName="user"
      [id]="'input-' + keyForId"
      type="text"
      [placeholder]="label ?? 'Buscar usuario'"
      class="form-control"
      style="max-height: 45px"
      [inputFormatter]="formatter"
      [ngbTypeahead]="search"
      [resultFormatter]="formatter"
      (focus)="focus$.next($any($event).target.value)"
      (click)="click$.next($any($event).target.value)"
      (selectItem)="onSelect($event.item)"
      (blur)="onBlur()"
      #instance="ngbTypeahead" />

    <label>{{ label ?? "Buscar usuario" }}</label>
  </div>

  <!-- MODO NORMAL Para qrs nacionales -->
  <div
    *ngIf="!useFloating"
    class="w-100"
    ngbTooltip="Comienza a escribir para buscar un usuario por nombre">
    <input
      formControlName="user"
      [id]="'input-' + keyForId"
      type="text"
      [placeholder]="label ?? 'Buscar usuario'"
      class="form-control w-100 input-match"
      style="height: 38px"
      [inputFormatter]="formatter"
      [ngbTypeahead]="search"
      [resultFormatter]="formatter"
      (focus)="focus$.next($any($event).target.value)"
      (click)="onInputClick()"
      (selectItem)="onSelect($event.item)"
      (blur)="onBlur()"
      #instance="ngbTypeahead" />
  </div>
</form>
